const KNOWN_SECTION_TYPES = new Set(["dashboardTitle", "metricGrid", "upcomingTrip"]);
const KNOWN_WIDGET_TYPES = new Set(["metricCard"]);

const requiredString = (value) => typeof value === "string" && value.trim().length > 0;

export function validateLayout(layout) {
  const errors = [];

  if (!layout || typeof layout !== "object") {
    return { valid: false, errors: ["Layout must be an object"] };
  }

  if (typeof layout.schemaVersion !== "number") {
    errors.push("schemaVersion must be a number");
  }

  if (!requiredString(layout.pageId)) {
    errors.push("pageId is required");
  }

  if (!Array.isArray(layout.sections) || layout.sections.length === 0) {
    errors.push("sections must be a non-empty array");
  } else {
    layout.sections.forEach((section, sectionIndex) => {
      if (!requiredString(section?.id)) {
        errors.push(`sections[${sectionIndex}].id is required`);
      }

      if (!requiredString(section?.type)) {
        errors.push(`sections[${sectionIndex}].type is required`);
      } else if (!KNOWN_SECTION_TYPES.has(section.type)) {
        errors.push(`sections[${sectionIndex}] has unknown type "${section.type}"`);
      }

      if (section?.type === "metricGrid") {
        if (!Array.isArray(section.widgets)) {
          errors.push(`sections[${sectionIndex}].widgets must be an array`);
          return;
        }

        section.widgets.forEach((widget, widgetIndex) => {
          if (!requiredString(widget?.id)) {
            errors.push(`sections[${sectionIndex}].widgets[${widgetIndex}].id is required`);
          }

          if (!requiredString(widget?.type)) {
            errors.push(`sections[${sectionIndex}].widgets[${widgetIndex}].type is required`);
          } else if (!KNOWN_WIDGET_TYPES.has(widget.type)) {
            errors.push(
              `sections[${sectionIndex}].widgets[${widgetIndex}] has unknown type "${widget.type}"`,
            );
          }

          if (widget?.type === "metricCard") {
            if (!requiredString(widget.metricKey)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}].metricKey is required for metricCard`,
              );
            }
            if (!requiredString(widget.labelKey)) {
              errors.push(
                `sections[${sectionIndex}].widgets[${widgetIndex}].labelKey is required for metricCard`,
              );
            }
          }
        });
      }
    });
  }

  return { valid: errors.length === 0, errors };
}

export function sanitizeLayout(layout) {
  if (!layout || typeof layout !== "object") {
    return null;
  }
  return layout;
}
